module.exports = __webpack_public_path__ + "static/banner1.d4962f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner1.png
// module id = KC9k
// module chunks = 0